import { Component, Input } from '@angular/core';
import { ViewModelProperty } from '../../models';

@Component({
    selector: 'ldw-vmp-form-group-item',
    templateUrl: './vmp-form-group-item.component.html',
    styleUrls: ['./vmp-form-group-item.component.css'],
    standalone: false
})
export class VMPFormGroupItemComponent {

  @Input() vmp: ViewModelProperty | undefined = undefined;
  @Input() captionWidth = 100;
  @Input() captionVisible = true;

  getItemWidth(): string {
    return 'width: ' + this.captionWidth + 'px;';
  }
}
